import { UserGroupMember } from '@matech/thebigpos-sdk'

import { UserRole } from '../../../../components/modals/ModalShareLoan'

const convertGroupMembersToUserRoles = (
	members: UserGroupMember[] | undefined
): UserRole[] => {
	const userRoles =
		members?.map(
			(item) =>
				({
					user: {
						id: item.user.id,
						name: item.user.name,
						email: item.user.email,
						role: item.user.role,
					},
					assignedRole: item.loanRole,
				}) as UserRole
		) || []

	return userRoles.sort((a, b) =>
		a.user.name.localeCompare(b.user.name)
	)
}

export default convertGroupMembersToUserRoles
